// Module
var code = "<ui-view/> <div ui-view=\"vyuctovanie\"></div> ";
// Exports
module.exports = code;